import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ResendTimer.scss';

export default class ResendTimer extends Component {
    state = {
        seconds: 15,
    }

    componentDidMount() {
        this.myInterval = setInterval(() => {
            const { seconds } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    render() {
        const { seconds } = this.state
        return (
            <div className="resendContainer">
                {seconds === 0
                    ? <div onClick={this.props.onClickFunction} className="resendClick">Resend</div>
                    : <div className="resendTimer">Resend in : {seconds} seconds</div>
                }
            </div>
        )
    }
}

ResendTimer.propTypes = {
    onClickFunction: PropTypes.func.isRequired,
};
